import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { InvoiceJustifications } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'ABONED_INVOICEJUSTIFICATION_',
  }
);

export interface AbonedInvoiceJustificationState {
  data: InvoiceJustifications | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface AbonedInvoiceJustificationRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: InvoiceJustifications;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: AbonedInvoiceJustificationState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: AbonedInvoiceJustificationState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: AbonedInvoiceJustificationState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: AbonedInvoiceJustificationState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: AbonedInvoiceJustificationState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const abonedInvoiceJustification = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const AbonedInvoiceJustificationTypes = Types;
export const AbonedInvoiceJustificationActions = Creators;
